import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge2 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権について' fontWeight={700} />
                <Heading3 title='ゴルフ会員権の発行形態' />
                <p>
                    ゴルフ会員権の発行形態には預託金制、株主会員制、社団法人制の３種類があり、日本のゴルフ場の大半は預託金制を採用しています。それぞれの制度の詳しい仕組みやゴルフ会員権のメリット・デメリットについては
                    <a href='/knowledge/8'>ゴルフ会員権とは？基礎知識とメリット・デメリットを解説</a>
                    で解説していますので、ぜひご参考ください。ここでは、発行形態のうち株主会員制と預託金制の違いについてもう少し詳しくご紹介します。
                </p>

                <Heading3 title='株主会員制と預託金制の違い' />
                <p>
                    預託金会員制と株主会員制のプレー権は同じです。しかし預託金会員制は、
                    施設利用権として、お金をクラブ経営会社に預けたことで会員の資格が発生し、優先プレー権・預託金返還請求権をもつ仕組みで、経営に関しては基本的に口を出すことは出来ません。
                    <br />
                    一方、株主会員制はプレー権を持つと同時に経営、運営に対しての株主総会、会員総会などで議決権をもつ事が出来ます。全会員が平等に同じ株数を持てば、発言権も平等にありますので理事長は単に会員である株主の代表という事になります。
                </p>

                <Heading3 title='ゴルフ会員権の登録' />
                <p>
                    <strong>
                        <u>１）個人会員</u>
                    </strong>
                    <br />
                    個人で入会し、その個人名義の会員権です。
                    <br />
                    <br />
                    <strong>
                        <u>２）法人会員</u>
                    </strong>
                    <br />
                    企業が接待ならびに福利厚生のために会社の資産として保有する会員権でそのほとんどが記名式です。登録可能な記名者は１名、２名などありますが、ほとんどが１名記名登録制です。記名登録者のみが会員として優先的利用権を行使出来ます。法人会員権の価格は記名2名式であれば個人正会員の2名分と同等の扱いとなりますが金額は必ずしも数に比例するわけではありません。
                </p>

                <Heading3 title='ゴルフ会員権の種類' />
                <p>
                    <strong>
                        <u>１）正会員</u>
                    </strong>
                    <br />
                    ゴルフクラブの休場日を除き全てプレーが可能で、全クラブ競技に参加可能です。また、委員・理事に選ばれてクラブ運営に参加することも出来ます。市場流通性がもっとも高い会員権です。
                    <br />
                    <br />
                    <strong>
                        <u>２）平日会員</u>
                    </strong>
                    <br />
                    ゴルフクラブの定休日を除く月～土曜日のプレーが可能であり、ゴルフクラブの定める平日競技に参加可能です。週休2日制の定着で土曜プレー可能な平日会員権は高い人気があります。（一部週日会員と呼ぶゴルフクラブもあります）
                    <br />
                    <br />
                    <strong>
                        <u>３）週日会員</u>
                    </strong>
                    <br />
                    プレー可能日が月～金曜日の平日であるため、正会員や平日会員と比べると入会者が限られます。（一部平日会員と呼ぶゴルフクラブもあります）
                    <br />
                    <br />
                    <strong>
                        <u>４）婦人会員</u>
                    </strong>
                    <br />
                    ゴルフ場施設などの制約から婦人会員権を設けているゴルフ場があります。この場合、女性が入会するためには婦人名義の会員権を購入し名義書換をする必要があります。また、会員数も限られるので会員権価格にプレミアムが付くことがほとんどです。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の購入について' fontWeight={700} />

                <Heading3 title='ゴルフ会員権はどうやって購入するか？' />
                <p>
                    ゴルフ会員権の購入方法は会員権取扱業者に依頼するのが一般的ですが、募集などゴルフクラブと直接取引する場合もあります。
                </p>

                <Heading3 title='ゴルフ会員権を購入する為に払うお金は？' />
                <p>ゴルフ会員権価格、売買手数料、名義書換料、年会費、入会金（預託金）等を払う必要があります。</p>

                <Heading3 title='ゴルフ会員権を購入するためにかかる消費税は？' />
                <p>
                    会員権取扱業者に依頼した場合＝会員権購入は課税対象となります。ゴルフクラブと直接取引した場合＝会員権購入は課税対象外となります。（ただし、年会費など会員権購入以外の金銭は課税対象となります。）
                </p>

                <Heading3 title='ゴルフ会員権を購入する際の注意点' />
                <p>
                    1.締結した売買をキャンセルする際には違約金を請求される事もありますので慎重にご検討ください。
                    <br />
                    2.名義書換料は入会者のご負担となります。
                    <br />
                    3.ゴルフ会員権業界の仕組み上、複数の業者に注文すると、市場に同一物件の複数登録がされ混乱を招く事になりますので、正式な注文はなるべく信頼出来る一社に任せましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の相場について' fontWeight={700} />

                <Heading3 title='ゴルフ会員権の相場はどのように決まるのか？' />
                <p>
                    実際に売買されているゴルフ会員権の相場は、需要（買い希望）と供給（売り希望）の金額によって決まる仕組みになっています。
                </p>

                <Heading3 title='ゴルフ会員権の相場が上昇する要因とは？' />
                <p>
                    ・入会条件の緩和及び名義書換料減額。
                    <br />
                    ・高速ICや駅などが新設され、アクセスが改善された場合。
                    <br />
                    ・コース改造、クラブハウス改築など施設（ハード面）がリフレッシュされた場合。
                    <br />
                    ・経済情勢の回復または好景気。
                    <br />
                    などがあります。
                </p>

                <Heading3 title='ゴルフ会員権の相場が下降する要因とは？' />
                <p>
                    ・ゴルフ場経営会社の破綻など著しく会員にとって不利益になった場合。
                    <br />
                    ・経済情勢の悪化・地政学的リスク。
                    <br />
                    ・長期会員募集による名義書換の停止。
                    <br />
                    ・名義書換料や入会預託金・年会費が上がる場合。
                    <br />
                    などがあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ場の入会について' fontWeight={700} />

                <Heading3 title='ゴルフ場の入会条件は？' />
                <p>
                    ゴルフ場に入会する場合、各ゴルフ場が定めた入会条件を満たす必要があります。以下に主な入会条件の例を説明いたしますが、ご不安を感じる場合はまず当社にご相談ください。
                    <br />
                    <br />
                    <strong>
                        <u>１）年齢制限</u>
                    </strong>
                    <br />
                    例：20才以上、35才以上など
                    <br />
                    <br />
                    <strong>
                        <u>２）女性制限</u>
                    </strong>
                    <br />
                    女性が入会する場合、現在女性名義の会員権を譲り受けなければ入会出来ないクラブもあります。（女性用の施設がキャパシティーオーバーになる事を防ぐ為に会員数を一定に保っています）
                    <br />
                    <br />
                    <strong>
                        <u>３）他クラブ在籍</u>
                    </strong>
                    <br />
                    入会希望者が既に他クラブ在籍している事を条件としており尚かつ、ＪＧＡ、ＫＧＡ加盟クラブに限定している場合があります。
                    <br />
                    <br />
                    <strong>
                        <u>４）推薦人、保証人</u>
                    </strong>
                    <br />
                    ゴルフクラブにより推薦人・保証人（クラブの正会員が多い）が1～2名必要な場合があります。具体的には署名･捺印（認印）から、署名、実印を捺印して、かつ印鑑証明書を添付し、別途推薦状を付けるなど、入会審査を推薦人、保証人に重きを置いている名門コースなどもあります。
                    <br />
                    <br />
                    <strong>
                        <u>５）面接</u>
                    </strong>
                    <br />
                    理事またはゴルフクラブ支配人と面接します。また面接時に推薦人・保証人の同伴をもとめる所もあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='まとめ' fontWeight={700} />
                <p>
                    ゴルフの楽しさを享受いただくためのゴルフ会員権ですが、その仕組みや売買に関してはまだまだ複雑かつ煩雑な現状がございます。ご質問や疑問点等ございましたら、当社までお気軽にお問合せください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge2;
